const initialState = {
    nft_list:[],
    register_partner_nft_list:[],
    wax_wallet_balances:[],
    got_nft_list:false,
    nbmfus_price:0,
    nbmact_price:0,
    nbmmin_price:0,
    nbmcon_price:0,
    nbmfus_defi_price:0,
    nbmact_defi_price:0,
    nbmmin_defi_price:0,
    nbmcon_defi_price:0,
    usdwax_median:0
}

const authorizedUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_NBMFUS_PRICE":
            return {...state, nbmfus_price:action.data.last_price};
        case "GET_NBMCON_PRICE":
            return {...state, nbmcon_price:action.data.last_price};
        case "GET_NBMACT_PRICE":
            return {...state, nbmact_price:action.data.last_price};
        case "GET_NBMMIN_PRICE":
            return {...state, nbmmin_price:action.data.last_price};
        case "GET_NFT_LIST":
            return {...state, nft_list: action.data, got_nft_list:true};
        case "GET_WAX_WALLET_CURRENCIES":
            return {...state, wax_wallet_balances: action.data.balances};
        case "GET_NFT_REGISTER_PARTNERS_LIST":
            return {...state, register_partner_nft_list: action.data, got_nft_list:true};
        case "GET_DEFI_NBMMIN_PRICE":
            return {...state, nbmmin_defi_price:action.data.data[0].price};
        case "GET_USDWAX_MEDIAN":
            return {...state, usdwax_median:action.data};
        case "GET_DEFI_NBMCON_PRICE":
            return {...state, nbmcon_defi_price:action.data.data[0].price}; 
        case "GET_DEFI_NBMACT_PRICE":
            return {...state, nbmact_defi_price:action.data.data[0].price}; 
        case "GET_DEFI_NBMFUS_PRICE":
            return {...state, nbmfus_defi_price:action.data.data[0].price};                         
        default:
            return state
    }
};

export default authorizedUserReducer
